<template>

  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-3">
        <h2><nobr>Work Report</nobr></h2>
      </div>
      <div class="col-6 text-center">
        <!--
          <div class="search-bar mx-auto">
              <input type="text" class="form-control" placeholder="Search Technicians...">
          </div>
          -->
      </div>
      <div class="col-3 text-end">
        <div class="btn-group">
          <!--
          <button class="btn btn-outline-primary btn-sm" type="button" @click="newTech()">
            <i class="fas fa-plus me-2"></i>New
          </button>
          -->
          <!--
            <button class="btn btn-outline-secondary" type="button">
                <i class="fas fa-bars"></i>
            </button>
            -->
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="ts" setup>


</script>